import { type DealTrackingMetric } from "@vega-api/generated/types/dealTrackingMetric";
import { formatMoneyShort } from "@vega-core/utils/formatMoney";
import { formatNumber, Rounding } from "@vega-core/utils/formatNumber";

export const METRIC_CARD_LOADING_PLACEHOLDERS = Array.from(
  { length: 4 },
  (_, index) => index,
);

export const getMetricDisplayValue = (metric: DealTrackingMetric): string => {
  if ("currencyMetricDiscriminator" in metric) {
    return formatMoneyShort(metric.moneyValue);
  }

  if ("percentageMetricDiscriminator" in metric) {
    const percentage = Number(metric.value);

    return isNaN(percentage)
      ? metric.value
      : `${formatNumber(percentage, Rounding.Always1Fractions)}%`;
  }

  return metric.value;
};
